import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import validationSchema from "./addTicketSchema";

export default function AddTicket({
  addTicketStatus,
  setAddTicketStatus,
  setChatItems,
  chatItems,
  setActiveChat,
}) {
  const [addTicket, setAddTicket] = useState({
    category_id: "",
    title: "",
    message: "",
    attachment: null,
  });
  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChangeTicketData = (event) => {
    setAddTicket({
      ...addTicket,
      [event.target.name]: event.target.value,
    });
  };

  const textFieldErrors = (field) => errors.find((e) => e.name === field);
  const helperTextErrors = (field) =>
    errors.find((e) => e.name === field)
      ? errors.find((e) => e.name === field).message
      : "";

  const handleAddTicket = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("category_id", addTicket.category_id);
    formData.append("title", addTicket.title);
    formData.append("message", addTicket.message);
    if (addTicket.attachment) {
      formData.append("attachment", addTicket.attachment);
    }

    validationSchema
      .validate({
        category_id: addTicket.category_id,
        title: addTicket.title,
        message: addTicket.message,
        attachment: addTicket.attachment,
      }, { abortEarly: false })
      .then(() => {
        setLoading(true);

        axios
          .post(
            "support-tickets/new-ticket",
            addTicket.attachment ? formData : addTicket
          )
          .then(({ data }) => {
            setLoading(false);
            toast.success(data.message);
            setAddTicketStatus(false);
            setChatItems([data.data, ...chatItems]);

            setActiveChat({
              attachment: null,
              info: {
                ...data.data,
                messages: [
                  {
                    attachment: data.data.messages[0].attachment,
                    message: data.data.messages[0].message,
                    message_id: data.data.messages[0].message_id,
                    sent_time: data.data.messages[0].sent_time,
                    user_avatar: data.data.messages[0].user_avatar,
                    user_name: data.data.messages[0].user_name,
                    isMine: true,
                  },
                ],
              },
              message: "",
              ticket_id: data.data.ticket_id,
            });
          })
          .catch(({ response }) => {
            setLoading(false);
            toast.error(response.data.message);
          });
      })
      .catch((err) => {
        const errors = err.inner.map((e) => {
          return {
            name: e.path,
            message: e.message,
          };
        });
        setErrors(errors);
      });
  };

  useEffect(() => {
    if (!addTicketStatus) return;

    axios
      .get("support-tickets/get-categories")
      .then(({ data }) => {
        setCategories(data.data);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
      });
  }, [addTicketStatus]);

  return (
    <div
      className="modal modal-sticky modal-sticky-lg modal-sticky-bottom-right d-block border border-dark"
      id="kt_inbox_compose"
      role="dialog"
      data-backdrop="false"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form id="kt_inbox_compose_form" onSubmit={handleAddTicket}>
            <div className="d-flex align-items-center justify-content-between py-5 pl-8 pr-5 border-bottom">
              <h5 className="font-weight-bold m-0">Add Ticket</h5>
              <div className="d-flex ml-2">
                <span
                  className="btn btn-clean btn-sm btn-icon"
                  data-dismiss="modal"
                  onClick={() => setAddTicketStatus(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
                        fill="#000000"
                      >
                        <rect x="0" y="7" width="16" height="2" rx="1"></rect>
                        <rect
                          opacity="0.3"
                          transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                          x="0"
                          y="7"
                          width="16"
                          height="2"
                          rx="1"
                        ></rect>
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
            <div className="d-block">
              <div className="form-group p-5 mb-0 align-items-center border-bottom inbox-to px-8 min-h-55px">
                <div className="w-100px">Title <span>*</span></div>
                <input
                  name="title"
                  type="text"
                  className={`form-control form-control-solid${textFieldErrors("title") ? " is-invalid" : ""}`}
                  placeholder="Enter title"
                  value={addTicket.title}
                  onChange={handleChangeTicketData}
                />
                {textFieldErrors("title") && (
                  <div className="fv-plugins-message-container">
                    <div
                      data-field="title"
                      data-validator={helperTextErrors("title")}
                      className="fv-help-block"
                    >
                      {helperTextErrors("title")}
                    </div>
                  </div>
                )}
              </div>
              <div className="form-group p-5 mb-0 align-items-center border-bottom inbox-to px-8 min-h-55px">
                <div>Select Category <span>*</span></div>
                <select
                  className={`form-control form-control-solid${textFieldErrors("category_id") ? " is-invalid" : ""}`}
                  name="category_id"
                  value={addTicket.category_id}
                  onChange={handleChangeTicketData}
                >
                  <option value="" selected disabled hidden>Select Category:</option>
                  {categories.map((category, index) => (
                    <option key={index} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
                {textFieldErrors("category_id") && (
                  <div className="fv-plugins-message-container">
                    <div
                      data-field="category_id"
                      data-validator={helperTextErrors("category_id")}
                      className="fv-help-block"
                    >
                      {helperTextErrors("category_id")}
                    </div>
                  </div>
                )}
              </div>
              <div className="form-group p-5 mb-0 align-items-center inbox-to py-2 px-8 min-h-55px">
                <div className="w-100px">Message <span>*</span></div>
                <textarea
                  placeholder="message here"
                  className={`form-control form-control-solid${textFieldErrors("message") ? " is-invalid" : ""}`}
                  name="message"
                  cols="30"
                  rows="5"
                  style={{ maxHeight: "100px", minHeight: "50px" }}
                  onChange={handleChangeTicketData}
                >
                  {addTicket.message}
                </textarea>
                {textFieldErrors("message") && (
                  <div className="fv-plugins-message-container">
                    <div
                      data-field="message"
                      data-validator={helperTextErrors("message")}
                      className="fv-help-block"
                    >
                      {helperTextErrors("message")}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex flex-column align-items-start gap-1 justify-content-between py-5 pl-8 pr-5 border-top">
              <div className="d-flex align-items-center mr-3">
                <div className="btn-group mr-4">
                  <button
                    type="submit"
                    className="btn btn-primary font-weight-bold px-6"
                    disabled={loading}
                  >
                    Send{loading ? "ing.." : ""}
                  </button>
                </div>
                <label htmlFor="addTicket-attachment" className="mb-0">
                  <span
                    className="btn btn-icon btn-sm btn-clean mr-2"
                    id="kt_inbox_compose_attachments_select"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                          d="M14,16 L12,16 L12,12.5 C12,11.6715729 11.3284271,11 10.5,11 C9.67157288,11 9,11.6715729 9,12.5 L9,17.5 C9,19.4329966 10.5670034,21 12.5,21 C14.4329966,21 16,19.4329966 16,17.5 L16,7.5 C16,5.56700338 14.4329966,4 12.5,4 L12,4 C10.3431458,4 9,5.34314575 9,7 L7,7 C7,4.23857625 9.23857625,2 12,2 L12.5,2 C15.5375661,2 18,4.46243388 18,7.5 L18,17.5 C18,20.5375661 15.5375661,23 12.5,23 C9.46243388,23 7,20.5375661 7,17.5 L7,12.5 C7,10.5670034 8.56700338,9 10.5,9 C12.4329966,9 14,10.5670034 14,12.5 L14,16 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(12.500000, 12.500000) rotate(-315.000000) translate(-12.500000, -12.500000) "
                        ></path>
                      </g>
                    </svg>
                  </span>
                </label>
                <input
                  type="file"
                  name="attachment"
                  id="addTicket-attachment"
                  hidden
                  onChange={(event) =>
                    setAddTicket({
                      ...addTicket,
                      attachment: event.target.files[0],
                    })
                  }
                />
              </div>
              {addTicket.attachment && (
                <div className="position-relative mt-5">
                  <svg
                    onClick={() => {
                      setAddTicket({
                        ...addTicket,
                        attachment: null,
                      });
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="25px"
                    height="25px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    style={{
                      position: "absolute",
                      borderRadius: "50%",
                      border: "1px solid red",
                      background: "rgb(113 19 45)",
                      cursor: "pointer",
                      top: "-10px",
                      right: "-10px",
                    }}
                  >
                    <g
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
                        fill="#fff"
                      >
                        <rect x="0" y="7" width="16" height="2" rx="1"></rect>
                        <rect
                          opacity="0.3"
                          transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                          x="0"
                          y="7"
                          width="16"
                          height="2"
                          rx="1"
                        ></rect>
                      </g>
                    </g>
                  </svg>
                  <img
                    width="100px"
                    className="rounded-card"
                    src={URL.createObjectURL(addTicket.attachment)}
                    alt="attachment"
                  />
                </div>
              )}
              {textFieldErrors("attachment") && (
                <div className="fv-plugins-message-container">
                  <div
                    data-field="title"
                    data-validator={helperTextErrors("title")}
                    className="fv-help-block"
                  >
                    {helperTextErrors("attachment")}
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
